import { Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { Email as EmailIcon } from "@mui/icons-material";
import { FormEvent } from "react";

interface ForgotPasswordProps {
  email: string;
  loading: boolean;
  onEmailChange: (email: string) => void;
  onSubmit: (e: FormEvent) => void;
  onBackToLogin: () => void;
  formClassName: string;
  codeButtonClassName: string;
  switchModeClassName: string;
}

const ForgotPassword = ({
  email,
  loading,
  onEmailChange,
  onSubmit,
  onBackToLogin,
  formClassName,
  codeButtonClassName,
  switchModeClassName
}: ForgotPasswordProps) => {
  return (
    <>
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary" align="center">
          Enter your email address and we'll send you a code to reset your password
        </Typography>
      </Box>
      
      <form className={formClassName} onSubmit={onSubmit}>
        <TextField
          label="Email Address"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          required
          fullWidth
          variant="outlined"
          helperText="We'll send a password reset code to this email"
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading}
          className={codeButtonClassName}
          startIcon={<EmailIcon />}
          sx={{ mt: 1 }}
        >
          {loading ? (
            <><CircularProgress size={20} sx={{ mr: 1 }} />Sending Reset Code...</>
          ) : (
            <>Send Reset Code</>
          )}
        </Button>
      </form>
      
      <Box textAlign="center" mt={2}>
        <Typography 
          variant="body2" 
          className={switchModeClassName}
          onClick={onBackToLogin}
        >
          Back to sign in
        </Typography>
      </Box>
    </>
  );
};

export default ForgotPassword;